import React from "react";
import Banner from "../components/story/banner";
import Propose from "../components/story/propose";
import MarryMe from "../components/story/marry-me";
import Accept from "../components/story/accept";
import StoryFooter from "../components/story/story-footer";

function Story() {
  return (
    <>
      <Banner />
      <Propose />
      <MarryMe />
      <Accept />
      <StoryFooter />
    </>
  );
}

export default Story;
